$(window).on('beforeunload', function(){
    $(window).scrollTop(0);
});

$( document ).ready(function() {
  
var tarotcards = [
  {
    "Card": "The Magician",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/1_-_Magician_result.png?v=1728493266",
    "Light": "Dreams made manifest\nCalling in resources\nDivine oversight",
    "Dark": "Wasted resources\nMissing an opportunity\nMisuse of power"
  },
  {
    "Card": "The High Priestess",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/2_-_HIgh_Priestess_result.png?v=1728493267",
    "Light": "Delivery of intuitive messages\nSpiritual initiation\nPresence of the goddess",
    "Dark": "Withdrawn and secretive\nBad at earth\nImpervious to external influence\nCold + austere"
  },
  {
    "Card": "The Empress",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/3_-_Empress_result.png?v=1728493265",
    "Light": "Maternal nurturance\nSacred creativity\nLove, pregnancy + fertility",
    "Dark": "Dependence on others\nDecadent, overly emotional\nVengeful + insecure"
  },
  {
    "Card": "The Emperor",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/4_-_Emperor_result.png?v=1728493262",
    "Light": "Stepping into leadership\nHealthy masculine energy\nStructures and routines",
    "Dark": "Trauma from the masculine\nUnfeeling + rigid\nPower struggles"
  },
  {
    "Card": "The Hierophant",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/5_-_Hierophant_result.png?v=1728493263",
    "Light": "Seeking a mentor and/or community\nCommitting to a spiritual practice\nExperiencing divinity",
    "Dark": "Didactic and dogmatic\nAdhering to outdated customs and conventions\nGiving away personal power to others"
  },
  {
    "Card": "The Lovers",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/6_-_Lovers_result.png?v=1728493264",
    "Light": "Intimate relationships\nLove and romance\nTransmutation through the union of opposites",
    "Dark": "Difficult decisions\nOverpowered by desire\nAmbivalence + ambiguity"
  },
  {
    "Card": "The Chariot",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/7_-_Chariot_result.png?v=1728493266",
    "Light": "Driven + ambitious\nHeroic efforts\nOvercoming obstacles",
    "Dark": "Aggressive + bulldozing\nBurnout\nUnrefined"
  },
  {
    "Card": "Strength",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/11_-_Strength_result.png?v=1728493263",
    "Light": "Self-mastery\nTaking the high road",
    "Dark": "Impulses of the lower self\nRepressed"
  },
  {
    "Card": "The Hermit",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/9_-_Hermit_result.png?v=1728493267",
    "Light": "Sacred solitude\nSelf-revelation\nAttaining wisdom",
    "Dark": "Reclusive + lonely\nNeglecting the physical body\nOverly analytical"
  },
  {
    "Card": "Fortune",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/10_-_Fortune_result.png?v=1728493265",
    "Light": "The forces of the universe conspiring in your favor\nGetting lucky\nBreaking unhealthy cycles",
    "Dark": "Repeating old patterns\nAt the mercy of external forces\nStressful change"
  },
  {
    "Card": "Justice",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/8_-_Justice_result.png?v=1728493260",
    "Light": "Balanced\nDefinitive decision making\nRefining personal value system",
    "Dark": "Human justice falling short\nLegal issues\nHarsh and strict"
  },
  {
    "Card": "The Hanged Man",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/12_-_Hanged_Man_result.png?v=1728493264",
    "Light": "Cellular transformation\nChange in perspective\nSuspending action + decision making",
    "Dark": "Alienation + Depression\nStuckness, suffering\nStruggle belonging"
  },
  {
    "Card": "Death",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/13_-_Death_result.png?v=1728493267",
    "Light": "Shedding the false self\nRelease from burdens\nFreedom",
    "Dark": "Difficult endings\nGrief and loss\nDeath"
  },
  {
    "Card": "Temperance",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/14_-_Temperance_result.png?v=1728493267",
    "Light": "Visitation from guides, angels or the departed\nHarmony between mind, body and spirit\nAvoid extremes, allowing miracles",
    "Dark": "Overly cautious\nMissing a loved one\nDivine intervention"
  },
  {
    "Card": "The Devil",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/15_-_Devil_result.png?v=1728493265",
    "Light": "Cathartic release\nExpression of shadow self\nA damn good time",
    "Dark": "Addiction\nToxic relationships\nMental imprisonment"
  },
  {
    "Card": "The Tower",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/16_-_Tower_result.png?v=1728493266",
    "Light": "Sudden revelation\nBreaking addictions\nFreedom",
    "Dark": "Chaotic upheaval\nDestruction\nTragedy"
  },
  {
    "Card": "The Star",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/17_-_Star_result.png?v=1728493265",
    "Light": "Rest and renewal\nBeing generous & experiencing generosity\nEnd of turmoil",
    "Dark": "Pouring too much out / wasted energy\nWeakened from trials\nQuestioning purpose"
  },
  {
    "Card": "The Moon",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/18_-_Moon_result.png?v=1728493265",
    "Light": "Guided by intuition\nNatural cycles\nIndulging your wildness",
    "Dark": "Mania / insanity\nNightmares\nLack of clarity"
  },
  {
    "Card": "The Sun",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/19_-_Sun_result.png?v=1728493264",
    "Light": "Vacation\nMoving somewhere warm\nRelief from darkness\nClarity + truth\nDivine masculine\nChildlike joy and wonder",
    "Dark": ""
  },
  {
    "Card": "Judgement",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/20_-_Judgement_result.png?v=1728493261",
    "Light": "Fulfilling your destiny\nStepping into healership\nRising above the fray",
    "Dark": "Confronted with remaining ego, selfishness\nChallenged to forgive the unforgivable\nThe spiritual will never win"
  },
  {
    "Card": "The Fool",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/0_-_Fool_result.png?v=1728493266",
    "Light": "New beginnings\nPrimordial instinct to live\nFearlessly open-hearted",
    "Dark": "Risky + Impulsive\nFailure to learn from the past or heed omens\nNo sense of self"
  },
  {
    "Card": "The Universe",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/21_-_Universe_result.png?v=1728493267",
    "Light": "Completion\nFulfillment\nArrival",
    "Dark": "Endings\nKarma"
  },
  {
    "Card": "Daughter of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Daughter_of_Wands_result.png?v=1728493263",
    "Light": "Young and wild and free\nMain character energy\nHot tempered + quick footed",
    "Dark": ""
  },
  {
    "Card": "Son of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Son_of_Wands_result.png?v=1728493264",
    "Light": "Acting from the ego\nPassionate and charismatic \nTrickster energy of The Magician",
    "Dark": ""
  },
  {
    "Card": "Mother of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Mother_of_Wands_result.png?v=1728493263",
    "Light": "Where the MILF archetype comes from.\nWarms herself and all around her with an internal flame\nPassionately pursues what she wants and protects her and hers.",
    "Dark": ""
  },
  {
    "Card": "Father of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Father_of_Wands_result.png?v=1728493262",
    "Light": "Pure fire energy in an evolved masculine container – daddy!\nVisionary.\nIs good at leading / directing others",
    "Dark": ""
  },
  {
    "Card": "Ace of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/1-_Wands_result.png?v=1728493260",
    "Light": "An inspiring new spark\nPossibility of a new direction\nIntuitive call to action",
    "Dark": ""
  },
  {
    "Card": "2 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/2_-_Wands_result.png?v=1728493263",
    "Light": "Discovery of potential\nNurturing the spark\nInciting change",
    "Dark": ""
  },
  {
    "Card": "3 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/3_-_Wands_result.png?v=1728493263",
    "Light": "Idea has taken on a life of its own\nA portal generated by inspiration\nView into the future",
    "Dark": ""
  },
  {
    "Card": "4 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/4_-_Wands_result.png?v=1728493266",
    "Light": "Enjoying the fruits of your labor\nWeddings, parties and celebrations\nInvesting in social life",
    "Dark": ""
  },
  {
    "Card": "5 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/5_-_Wands_result.png?v=1728493260",
    "Light": "Outer and inner chaos\nPointless conflict with others\nMisdirected energy and efforts",
    "Dark": ""
  },
  {
    "Card": "6 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/6_-_Wands_result.png?v=1728493266",
    "Light": "Taking the high road to a victory\nDawn after the dark\nFairness + integrity",
    "Dark": ""
  },
  {
    "Card": "7 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/7_-_Wands_result.png?v=1728493266",
    "Light": "Asserting autonomy and independence\nCourage to let go of what no longer serves\nCharting your own path",
    "Dark": ""
  },
  {
    "Card": "8 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/8_-_Wands_result.png?v=1728493262",
    "Light": "Rapid growth or movement \nSwift action\nCollective purpose",
    "Dark": ""
  },
  {
    "Card": "9 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/9_-_Wands_result.png?v=1728493263",
    "Light": "Stamina and perseverance\nKeeping the faith\nRising after a fall",
    "Dark": ""
  },
  {
    "Card": "10 of Wands",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/10_-_Wands_result.png?v=1728493264",
    "Light": "Burned out / uninspired\nOverwhelmed and overburdened\nThe need to pare down",
    "Dark": ""
  },
  {
    "Card": "Daughter of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Daughter_of_Cups_result.png?v=1728493263",
    "Light": "Imaginative, dreamy, sensitive.\nCreativity and curiosity without ambition.\nEmpathetic, idealistic – naturally inclined to see the beauty / good in things.",
    "Dark": ""
  },
  {
    "Card": "Son of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Son_of_Cups_result.png?v=1728493264",
    "Light": "Inner vision\nEmotional depth\nPractical application of creativity in the world.",
    "Dark": ""
  },
  {
    "Card": "Mother of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Mother_of_Cups_result.png?v=1728493259",
    "Light": "Open hearted, nurturing, loving.\nEmotional intelligence \nInutitive healing abilities",
    "Dark": ""
  },
  {
    "Card": "Father of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Father_of_Cups_result.png?v=1728493265",
    "Light": "Self-control and self-mastery\nUnexplored emotional depths\nProne to emotional unavailability, depression and addiction.",
    "Dark": ""
  },
  {
    "Card": "Ace of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/1_-_Cups_result.png?v=1728493260",
    "Light": "Healing relationship to self\nEmotions surfacing within\nRenewal of health",
    "Dark": ""
  },
  {
    "Card": "2 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/2_-_Cups_result.png?v=1728493263",
    "Light": "Beginning stages of romantic love\nSymbiotic relationships\nReconciliation",
    "Dark": ""
  },
  {
    "Card": "3 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/3_-_Cups_result.png?v=1728493264",
    "Light": "Platonic love\nEmotional support\nBeing where you belong",
    "Dark": ""
  },
  {
    "Card": "4 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/4_-_Cups_result.png?v=1728493266",
    "Light": "Self-pity\nRefusing resources\nDiscernment",
    "Dark": ""
  },
  {
    "Card": "5 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/5_-_Cups_result.png?v=1728493261",
    "Light": "Loss + grief\nEmotional crisis\nNot all is lost",
    "Dark": ""
  },
  {
    "Card": "6 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/6_-_Cups_result.png?v=1728493267",
    "Light": "Childhood memories\nNostalgia + sentimentality\nRevisiting / examining the past",
    "Dark": ""
  },
  {
    "Card": "7 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/7_-_Cups_result.png?v=1728493262",
    "Light": "Overindulgence\nTemptation + illusion\nEmotional instability",
    "Dark": ""
  },
  {
    "Card": "8 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/8_-_Cups_result.png?v=1728493267",
    "Light": "Unfulfilling endeavors\nEmotional stagnation / rot\nMoving on",
    "Dark": ""
  },
  {
    "Card": "9 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/9_-_Cups_result.png?v=1728493264",
    "Light": "Creativity + fertility\nWishes coming true \nVacation",
    "Dark": ""
  },
  {
    "Card": "10 of Cups",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/10_-_Cups_result.png?v=1728493262",
    "Light": "Emotional fulfillment\nHappy family life\nPerfected love",
    "Dark": ""
  },
  {
    "Card": "Daughter of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Daughter_of_Pentacles_result.png?v=1728493261",
    "Light": "Grounding into the earth\nFertilization of new ideas\nBeing teachable",
    "Dark": ""
  },
  {
    "Card": "Son of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Son_of_Pentacles_result.png?v=1728493264",
    "Light": "Diligent and hardworking\nDoing what you say you're going to do\nRespect for traditions and structure",
    "Dark": ""
  },
  {
    "Card": "Mother of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Mother_of_Pentacles_result.png?v=1728493264",
    "Light": "Practical and resourceful, adept at harvesting abundance from the material world\nConnected to nature, physical health, and sensual pleasures.\nNurturing and supportive",
    "Dark": ""
  },
  {
    "Card": "Father of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Father_of_Pentacles_result.png?v=1728493265",
    "Light": "The vibe of presidents, CEO’s and sugar daddies.\nMaster of the material world.\nLeadership and responsibility",
    "Dark": ""
  },
  {
    "Card": "Ace of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/1_-_Pentacles_result.png?v=1728493263",
    "Light": "A new opportunity\nHumble but promising beginnings\nGrowing something from seed",
    "Dark": ""
  },
  {
    "Card": "2 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/2_-_Pentacles_result.png?v=1728493263",
    "Light": "Balancing and prioritizing resources\nIntegration\nManaging multiple responsibilities",
    "Dark": ""
  },
  {
    "Card": "3 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/3_-_Pentacles_result.png?v=1728493267",
    "Light": "Co-working and cooperation\nTeamwork makes the dream work\nFeeling valued for your efforts",
    "Dark": ""
  },
  {
    "Card": "4 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/4_-_Pentacles_result.png?v=1728493266",
    "Light": "Greed and hoarding\nHolding on too tightly / constricting flow\nKeeping score",
    "Dark": ""
  },
  {
    "Card": "5 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/5_-_Pentacles_result.png?v=1728493266",
    "Light": "A bad harvest\nIllness and poverty\nLoss of resources / security",
    "Dark": ""
  },
  {
    "Card": "6 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/6_-_Pentacles_result.png?v=1728493267",
    "Light": "Generosity\nSharing resources\nMutual aid",
    "Dark": ""
  },
  {
    "Card": "7 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/7_-_Pentacles_result.png?v=1728493267",
    "Light": "Long term investment\nPlanning + organization\nPatience",
    "Dark": ""
  },
  {
    "Card": "8 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/8_-_Pentacles_result.png?v=1728493264",
    "Light": "Sacred work + master craftsmanship\nBuilding a life for yourself\nBeing a connector",
    "Dark": ""
  },
  {
    "Card": "9 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/9_-_Pentacles_result.png?v=1728493265",
    "Light": "Material abundance\nWarm, good home vibes\nFinancial independence",
    "Dark": ""
  },
  {
    "Card": "10 of Pentacles",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/10_-_Pentacles_result.png?v=1728493267",
    "Light": "Financial plenty\nCelebrating what you have\nMaterial gratification",
    "Dark": ""
  },
  {
    "Card": "Daughter of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Daughter_of_Swords_result.png?v=1728493262",
    "Light": "Comomon sense\nDeep observer and active listener\nSharp intelligence",
    "Dark": ""
  },
  {
    "Card": "Son of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Son_of_Swords_result.png?v=1728493262",
    "Light": "Singular focus on a goal.\nDutiful. Obsessive. Intense. Decisive.\nSometimes fierce and brutal.",
    "Dark": ""
  },
  {
    "Card": "Mother of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Mother_of_Swords_result.png?v=1728493262",
    "Light": "Highly discerning to the point of suspicious.\nStrict and cold.\nTruth seeker who will speak truth to power.",
    "Dark": ""
  },
  {
    "Card": "Father of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Father_of_Swords_result.png?v=1728493263",
    "Light": "Rationality, logic, and mental clarity. \nAnalytic and principled.\nIntegrity for days.",
    "Dark": ""
  },
  {
    "Card": "Ace of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/1_-_Swords_result.png?v=1728493261",
    "Light": "A new idea\nThe written word\nCutting ties/cords",
    "Dark": ""
  },
  {
    "Card": "2 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/2_-_Swords_result.png?v=1728493260",
    "Light": "Indecision, stalemate\nBlocked vision\nConflicting ideas",
    "Dark": ""
  },
  {
    "Card": "3 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/3_-_Swords_result.png?v=1728493262",
    "Light": "Acute pain and suffering\nSelf-betrayal of betrayal from others \nIrrevocable change, irreparable damage",
    "Dark": ""
  },
  {
    "Card": "4 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/4_-_Swords_result.png?v=1728493267",
    "Light": "Rest from conflict\nTruces and treaties\nBeing vulnerable",
    "Dark": ""
  },
  {
    "Card": "5 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/5_-_Swords_result.png?v=1728493261",
    "Light": "Self-harm, self-inflicted diminishment / destruction\nNegative thinking\nDishonorable victory",
    "Dark": ""
  },
  {
    "Card": "6 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/6_-_Swords_result.png?v=1728493261",
    "Light": "Replacing discordant thoughts with harmonious ones\nTravel\nMental clarity",
    "Dark": ""
  },
  {
    "Card": "7 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/7_-_Swords_result.png?v=1728493265",
    "Light": "Hidden / withheld information\nDeliberate dishonesty + cheating\nKarma",
    "Dark": ""
  },
  {
    "Card": "8 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/8_-_Swords_result.png?v=1728493263",
    "Light": "Mental paralysis\nOverwhelming doubt and fear\nDisempowerment",
    "Dark": ""
  },
  {
    "Card": "9 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/9_-_Swords_result.png?v=1728493266",
    "Light": "Anxiety\nNightmares\nMental detox/Processing old trauma",
    "Dark": ""
  },
  {
    "Card": "10 of Swords",
    "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/10_-_Swords_result.png?v=1728493267",
    "Light": "Mental ruin\nUnhappy ending / painful goodbye\nUnfixable situation",
    "Dark": ""
  }
];
  
var oraclecards = [
 {
   "Card": "11:11",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/11_11.png",
   "Description": "The crown jewel of time magic. 11:11 descends twice daily on the wings of angels and invites its witness to make a wish. \n \nThis wish portal opens so frequently that one must wonder if the universe requires wishes in much the same way an automobile requires gasoline. Or, perhaps, Spirit delights in receiving wishes in much the same way as humans revel in casting them. Whether they are an essential resource or luxury item in the Spirit World, a wish cast, or rather, the belief behind casting said wish, carries value across dimensions. It may, in fact, be what makes this whole thing go.\n \nFor the weary traveler, and those who, for an array of reasons, have lost faith in the efficacy of wish-making, this recurring visitor is merely a tick of the clock. Unnoticed but inexorable. A quiet, perpetual invitation to hope. \n \nIn either case, it offers only a slight smile, a squeeze on the shoulder, a mischievous wink before dissolving back into infinity. "
 },
 {
   "Card": "Acceptance Is The Answer",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/AcceptanceIsTheAnswer.png",
   "Description": "It need not be embraced, condoned, or normalized, but neither can it be denied. To resist pain is to feel pain. To deny reality only places the burden of denial atop the burden of reality. To yield, like water does to denser matter, is not to cower, but to dance. Acceptance is a way to move in tandem with Reality as well as a known ingredient in Serenity. "
 },
 {
   "Card": "Aggressively Hydrate",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/AggressivelyHydrate.png",
   "Description": "While the body can, at times, feel like an untold mystery, its needs are basic and its functions largely self-supporting when properly fueled. For optimal operation of your celestially-assigned vessel, aggressively hydrate whenever possible. Do it now. "
 },
 {
   "Card": "An Answer But Not The Solution",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/AnAnswer920.png",
   "Description": "The shortest distance between point A and point B is a straight line. Then there’s all the other possible ways. \n \nHumans are a game-loving species, one who invokes a mercy rule in competitive sports to cut short a foregone match. One who enjoys the seductive tension between present and future and, in large part, depends on not knowing the outcome. If all roads eventually lead to the mountaintop and plot twists are a large part of the “point,” if not the point itself, then it would stand to reason it’s not always in our best interest to prioritize efficiency over experience. \n \nThere is a time for wandering, to be sure. To wander is human; to arrive is divine. Are you appreciating the scenic route or lost in the maze? Is there a more elegant solution available that you’re missing? Are you animated by the thrill of the game or are you just playing yourself?"
 },
 {
   "Card": "The Backrooms",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Backrooms.png",
   "Description": "A particularly ominous denomination of the Liminal Space. Entered through a Glitch or Shift or Noclip, The Backrooms are found just underneath the scaffolding of the simulation. Those who find themselves in this endless labyrinth of randomly segmented rooms and halls, furnished with aged carpet, stained walls and buzzing lights describe it as oddly familiar and darkly nostalgic.  \n\nIts existence, if accepted, all but proves the presence of a creator. It also calls into question if our god is more of a gamemaker, its progeny a result of masterful programming, the unobservable edge of the universe merely where the coding has yet to be written. \n\nThere is no known escape from The Backrooms, just as there is no physical entrance. Because this realm warps time and memory, any information regarding it remains unverifiable by all presently available methods. \n\nMore people are stuck here than you think, captive to the numbing repetition and crushing tedium of a life they refuse to choose."
 },
 {
   "Card": "Be Groovy Or Leave, Man",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BeGroovyOrLeaveMan.png",
   "Description": "Mutualistic symbiosis depends upon a common agreement to abide by the rules and customs of the ecosystem you inhabit. To refuse to do so risks the grave offense of killing the vibe. It is not your place to kill the vibe, but it is also your duty to protect your grooviness.\n \nContemplate the spaces you occupy, the memories you return to, and what they bring up in you. This basement, littered with Postcards Easter eggs, echoes relics of what once was but is no longer. It is possible you have outgrown this place. \n \nIf you’re no longer feeling groovy here, it’s time to leave."
 },
 {
   "Card": "Believe Nothing That You Hear And Only Half Of What You See",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BelieveNothing920.png",
   "Description": "It’s beneficial to remain aware of the astonishing subjectivity of perception, for consciousness is informed by countless experiences and conditions unique to the individual. What you are hearing and seeing, telling and being told, are spiked with the self-deception that is inherent to the human condition. \n \nA map is not the same as the territory it represents, nor is your perception of truth necessarily True. Words are symbols that fail to fully grasp the nature of reality. Reality itself is a fragile and subjective operating system. If language can serve only as a pale construct of a reality that eludes us, both concepts must be understood to be imperfect. What are you left with, now?\n \nA tonic for the anxious mind to not believe every thought that passes through. "
 },
 {
   "Card": "Beware: Nostalgia",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BewareNostalgia.png",
   "Description": "A state of being native to Memory Lane. Like Nightshade flora, this species holds nutritional value in moderation while toxic or even lethal in larger doses. A bout of nostalgia, in all its wistful splendor, can move an individual to call their mother or write a poem or play a record and cry or laugh or sing or sigh. Its benefits span from fleeting tenderness to deep catharsis. \n           \nWhen consumed in excess, however, symptoms may include depression, delusion and impaired executive functioning. If you or a loved one have overindulged in nostalgia, please secure all electronics in another room until effects have passed. \n \nIn rare instances, the effects do not pass. Untended, nostalgia’s secret gardens grow thick and wild. Its subject is bound to the locked gates, protecting the fortress whose doors cannot be entered, whose windows can only be peered through. There is nothing to be done for someone this inextricably bound to their sadness. The decision to leave the departed and unrequited behind and rejoin the land of the living is deeply personal and immensely difficult, but always possible. \n \nThis is a spell, sometimes a curse, always a threshold. And thresholds are not to be lingered on. "
 },
 {
   "Card": "Blood Sacrifice",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BloodSacrifice.png",
   "Description": "Cognitive dissonance occurs when an individual’s behavior conflicts with their personal morality, causing them to separate their actions from the consequences they produce. This practice preserves the ego at the expense of the Soul. In addition to enabling the masses to participate in atrocities they would never consciously condone, it creates a debt in the spirit world that isn’t acknowledged in the physical, driving a wedge between this essential connection and with it, an existential sense of loss. \n \nThe universe accepts payment in blood. It’s a form of fuel, but a peculiar one. Make sure every choice you make is one you can live with, because live with it you must. What do you need that requires blood, and can you live with it on your hands?"
 },
 {
   "Card": "Body Scan",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BodyScan.png",
   "Description": "This body, in all its cellular memory, is your home. The Kingdom embedded in your flesh. The vehicle your spirit chose to animate itself and make its will manifest. \n \nThis is a divine container, a sacred binding with its own rhythms and tickings, constantly performing miracles we can scarcely fathom, storing what the mind forgets. Your Soul has known many bodies and will know many more. Your body’s penultimate destiny, however, is to house your Soul for this lifetime. The stardust that makes you has waited since the beginning of time to assume this form. To check in with your body is an expression of hygiene and prayer."
 },
 {
   "Card": "Bring Your Own Seat To The Table",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BringYourOwnSeat920.png",
   "Description": "An invitation, an imperative, and possibly a challenge: to show up authentically with your imperfect offering. To mimic another is delusion, to covet another’s seat is destructive fantasy. The work is wanting what you have and seeing the value in your unique contribution. Bring your own seat to the table and know that is enough."
 },
 {
   "Card": "Broke Is The Beginning",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BrokeIsTheBeginning.png",
   "Description": "It might not be much, but it’s yours for the taking. Someone less creative, brilliant, determined and imaginative might view this as a setback, but a Trash Magician will see the possibilities. Take your terror with your excitement, your uncertainty with your electricity, and let them all guide you forward."
 },
 {
   "Card": "Burn The Idols",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/BurnTheIdols920.png",
   "Description": "A fiery crescendo fitting the late-stage capitalist hellscape we find ourselves in. It cannot be stopped at this point, but how we found ourselves here may be of interest to those in the business of breaking cycles. To idolize – to worship as a god, or love or admire in excess – can produce ecstasy in the idolizer. The blithe serenity of the cult member, certain they have found their way back to the Garden, speaks to this condition’s precarious nature. \n \nWhile idolization and Love are often conflated, they are in fact opposites. Where Love is free-flowing and infinite, idolization is dogmatic and conditional. Where Love is appreciation of what is, idolization is a dual pipe-dream of what could never be. \n \nIf all actions produce an equal and opposite reaction, then one matter is glorified while another is vilified. More interestingly, the same glorified matter ultimately becomes vilified upon the worshipper's realization that its beloved idol reflects their own corrupted self-image, at which point the catharsis of burning the idol outweighs the consolation of venerating it.  \n \nIt would stand to reason the collective is better off with no idols at all."
 },
 {
   "Card": "Butterfly Dreams",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/ButterflyDreams920.png",
   "Description": "The fruits of your current reality were sown as seeds in a past one. Every version carries clues of your becoming, as well as choices that will inform it. What was once a poster on the wall is now a car in your garage. The notes in your journal, now a book. Your dreams for the future, made real in the present. This is how life moves. \n \nDoes the caterpillar have any way of conceptualizing what it will become at the onset of its chrysalis? Do you?\n \nPerhaps it feels like dying. Possibly they sense, deep in their primordial ooze, that they are being reborn. Perhaps both are true."
 },
 {
   "Card": "Carefree Timelessness",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/CarefreeTimelessness920.png",
   "Description": "A byproduct of Love. Carefree Timelessness occurs when we are fully and meaningfully engaged with the present moment. Most often it’s a mindful choice to set aside distractions. In rare instances, there is no choice required, and you are simply gripped by the glory of the here and now. The former will, over time, lead to the latter."
 },
 {
   "Card": "Carry Your Weather",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/CarryYourWeather.png",
   "Description": "An urging to consider the impact of your energy. Ever-changing but omnipresent, your state of being creates a ripple in every ecosystem you enter. You cannot always control the nature of this influence, but profound self-recognition can occur by taking responsibility for it. Accounting for your weather is a form of mastery."
 },
 {
   "Card": "Cord Cutting",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/CordCutting.png",
   "Description": "I cut the cord that ties the bind\nagreements set and contracts signed \nacross all planes of space and time \nthat connects you and me.\n \nMay the Rhythms of Fate and Tickings of Time\nbe in your favor and Luck on your side \nand should you reach may ever you find\nwhat it is you seek.\n \nTruth will out and justice blind \ndo not regret what’s left behind \nlessons learned and peace of mind \npersist strongest in memory. \n \nOur destinies, once intertwined \nnow yours is yours and mine is mine \nwith gratitude I unassign\nwith courage I release. \n \nTo the goddess I petition \na total and complete remission \nSo be it. So mote it be."
 },
 {
   "Card": "Cosmic Fuckery",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/CosmicFuckery920.png",
   "Description": "The improbable majesty of our very existence, spinning on a space rock orbiting a giant ball of flames is, in and of itself, a form of Cosmic Fuckery. The stars are our ancestors, speaking the collective language of the invisible. For millennia humans have looked up and studied the heavens; the methods in the madness mirror our own, as we are their children. To those who have found meaning in the cosmos, they too have found meaning in you. \n \nIf you find yourself screaming into the void, make sure to listen for the response. Most of the time, you will find them laughing. The wise will join them."
 },
 {
   "Card": "Dimensional Shift",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/DimensionalShift.png",
   "Description": "Prevailing scientific theory posits we live in a constantly expanding universe, originating from a Big Bang whose stupendous velocity propels it outward evermore. As a result of this infinite momentum, or perhaps because we ourselves are the infinite momentum, the edge of the universe is unobservable to the human eye. We can only look backward, and when we do, we find traces of a flat universal plane that neither curves nor reflects on itself. Because a colossal explosion traveling in only two dimensions is a scientific impossibility, we are forced to reckon with the formidable limitations of our perception.\n \nThe human eye, in all its three-dimensional roundness, can only see two dimensions. The miracle of depth perception is the processing of a series of retinal disparities. This means our bodies, as well as the realities that buoy them, exist in dimensions we cannot fully perceive. The concept of dimensionality is one modern science has scarcely scratched the surface, because even the most expansive minds cannot objectively observe an experiment they are a part of. \n \nTrying to understand what a thing is by observing an imprint of what it once was is no more conclusive than relying on memory to accurately account for the past. In another dimension, that past is the future. In another, that past never came to pass at all. \n \nOn a myopic level, a sudden upheaval has changed you forever. You are a different version of yourself than you were before. This cannot be undone."
 },
 {
   "Card": "Divine Mother",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/DivineMother920.png",
   "Description": "All that lives and breathes came from a Mother. Transcending the strengths and failings, sins and virtues of any individual mother, The Divine Mother speaks to an omnipotent power. Like the forces of Fate, Time and Love, alongside the archetypes of the Goddess, Empress, Priestess and Virgin Sun Queen, she is a signpost on the larger cosmic map of which we are all composed. A clue of heaven, earthside. \n \nEvery breath you breathe is a prayer of gratitude to the Mother. Every breath taken from you is a trespass against the Mother. \n \nShe is also who we return to when we ourselves have trespassed. She listens to the pleas for forgiveness, prayers to break contracts and petitions for grace. She reminds us that to be embraced and cradled, held and forgiven, is our birthright. She is a safe space in a dangerous realm, a soft spot in a hard world. She has chosen this and this is her power. \n \nNo one is impervious to the need for the Divine Mother’s love. Reach for it and it will always, somehow, reach back for you."
 },
 {
   "Card": "Down In The River",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/DownInTheRiver.png",
   "Description": "All that’s promised is the sun will rise and the moon will rise and the river will rush and we can make of that what we will. We watery beings understand the river to be a place of renewal, a source of life and a mirror of the rushing life within us. Intuitively, historically and collectively the river is known as a place to pray, to be reborn, to release burdens, to seek ease. It’s a gentle companion to the imagination. It sits vigil with restless thoughts. \n \nIf you listen, you will hear the water calling you back again and again. If you find yourself lost, make your way to the river. You do not need to fully understand this medicine to benefit from it."
 },
 {
   "Card": "Energy Follows Intention",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/EnergyFollowsIntention.png",
   "Description": "The human brain, composed of billions of nerve cells and trillions of synapses, generates enough electricity to power a lightbulb and processes information 300x faster than the fastest computer. Breakthrough technology can translate mental commands into physical control of objects through the power of thought alone. The mind, much like the Universe, is both beyond comprehension and constantly revealing itself. \n \nBut before any of this was known, the premise that thoughts have power has been touted and utilized since the ancients. Like all science, this was magic before its mechanics were observed. That energy follows intention is a fundamental rule of magic. \n \nIt may not happen if you think about it, but if you don’t think about it, it will never happen."
 },
 {
   "Card": "Enough Is A Feast",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/EnoughIsAFeast920.png",
   "Description": "“For if you know what you want, and will be content with it, you can be trusted. But if you do not know, your desires are limitless and no one can tell how to deal with you. Nothing satisfies an individual incapable of enjoyment.”\n― Alan Wilson Watts, The Book on the Taboo Against Knowing Who You Are"
 },
 {
   "Card": "Esse Quam Videri",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/EsseQuamVideri.png",
   "Description": "To be, rather than to seem. \nThe North Carolina State Motto."
 },
 {
   "Card": "Eureka!",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Eureka.png",
   "Description": "I have found it!\nThe California State Motto."
 },
 {
   "Card": "Excelsior",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Excelsior.png",
   "Description": "Ever upward. \nThe New York State Motto. "
 },
 {
   "Card": "Eye For An Eye",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/EyeForAnEye.png",
   "Description": "Eye for an Eye is a false teaching; revenge masked as Justice, a breeding ground for Curses and an assault on the Divine Mother. It is to be Burned with the Idols, or simply put down in favor of peace, which is what the Divine Mother would do. \n \nAn individual or societal concept of fairness and the force of Justice are not synonymous."
 },
 {
   "Card": "Fortune Favors The Bold",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/FortuneFavorsTheBold920.png",
   "Description": "The Tarot recognizes Fortune as one of its twenty-two Major Arcana, or primary mysteries. You should too. A necessary power to harness when working with money magic, significant transitions, adventures and all matters of Luck."
 },
 {
   "Card": "The Fuckening",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Fuckening920.png",
   "Description": "Sometimes things go deeply wrong. This is one of those times. The fire will go out eventually, and you can come back and see what’s left once it does. Or not."
 },
 {
   "Card": "Hand In Hand",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/HandInHand.png",
   "Description": "When feeling Alone in this Uncertain Place, you may visit the veil. The archway between life and death, present and past, where lost things go to await finding – for you too are sometimes one of those lost things and at those times you belong among them. \n \nWhat you seek is seeking you, even the seemingly impossible. The sheer power of your longing cannot resurrect the dead in this realm, but it can awaken them and call them close. Your yearning passes through the veil by speaking the language of the invisible, and, for a moment, those on the other side hold your hand when you need it most."
 },
 {
   "Card": "The Hell Train",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/HellTrain920.png",
   "Description": "Too late, this unavoidable confrontation is a long time coming. Toot toot bitch, it’s here. "
 },
 {
   "Card": "Hiding In Plain Sight",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/HidingInPlainSight.png",
   "Description": "A calling back to awareness. Reality is attention paid to the puzzle pieces we’re inclined to see, but the ones we miss are equally if not more curious. It’s been right there all along. "
 },
 {
   "Card": "The High Road",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/HighRoad.png",
   "Description": "There is a magnificent idea available that will solve a multitude of issues, but accessing it requires seeing beyond what is, to what should be. A solution, rather than an answer. Keep imagining until you reach an outcome where everyone wins. If you can achieve that level of genius, something positive and productive blooms on this mortal coil."
 },
 {
   "Card": "The Hot Tub's Too Hot",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/HotTubsTooHot.png",
   "Description": "While mania is thrilling and the creative output of this altered state prolific, its invariable, subsequent crash ranges from devastating to deadly. Despite the risks, some travelers feel an imperative to explore all possible realms of consciousness. Others have no choice. \n \nHaving failed to heed dangerously rising temperatures, you are now up too high and overheating too fast. Emergency evacuation may be required. Nourishment, sleep and hydration are key to safe de-escalation. Focus on little else until this is achieved."
 },
 {
   "Card": "I See That You Are Here And I Am Glad",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/ISeeThatYouAreHere.png",
   "Description": "Appreciating the presence of another is the equivalent of offering a plant water and sunlight. \nSee also: I Love you."
 },
 {
   "Card": "Infinity Mirror",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/InfinityMirror.png",
   "Description": "A glimpse into the multiverse through a serendipitous alignment of quotidian objects."
 },
 {
   "Card": "It Takes A Curse To Break A Curse",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/ItTakesACurse920.png",
   "Description": "To break a curse is to behead a Hydra. When the very act of breaking one creates another, producing evermore curses to account for its predecessor, alternatives to the act of breaking must be considered. \n \nMuch like how cutting off the original head from which all the others grow slays the monster, at the crux of this quandary lies its solution. The cycle keeping the curse alive must be altogether uprooted, opted out of and unsubscribed from. Like putting down something very heavy, like upending something very deep. Forgiveness. This is an act of Soul retrieval. "
 },
 {
   "Card": "Kill Your Darlings",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/KillYourDarlings.png",
   "Description": "There is bravery in breaking your own heart and now is the time to be brave. \n \nIn writing, darlings are the most loved and therefore most overused phrases by writers. In life, they are habits, addictions, laurels and comforts. To avoid becoming boring and predictable, Kill a Darling. Doing so will invariably lead to a fresher source of inspiration."
 },
 {
   "Card": "Kneel Before No One",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/KneelBeforeNoOne.png",
   "Description": "Pride is a sin, but dignity is a necessity. Pride will cost everything and leave you with nothing. Without dignity, however, you lose yourself, at which point nothing is worth having. \n \nAs a human being, a member of a community, an interdependent participant of an interconnected web – embrace humility, make amends for harm caused, clean up your side of the street at every opportunity and don’t be an asshole. \n \nAs compressed stardust, a microcosm of the universe itself, a child of these awesome cosmos – never accept crumbs. Stand on your feet, hold your head up, look them in the eye and Kneel Before No One."
 },
 {
   "Card": "Knock Knock Tick Tock",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/KnockKnockTickTock.png",
   "Description": "Time is a construct that cannot be possessed and therefore cannot be lost, and yet... the dogged notion it’s running out, or rather, you are running out of it."
 },
 {
   "Card": "Know Thyself",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/KnowThyself.png",
   "Description": "Above all else."
 },
 {
   "Card": "Let It Break",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/LetItBreak.png",
   "Description": "Let it fall apart. Let it come back together and let it fall apart again. Instead of trying to control the movement, learn to pivot alongside it. Oftentimes things need to break to become something else. On a literal level, muscles tear during exercise to grow back stronger. Minerals with fractures let in the light in and make possible the presence of rainbows. Explore the prospect of breaking without being broken. Explore that breaking may simply be a means of opening. \nWhether you must do the deed or simply allow it, breaking something or permitting it to break is, in this case, an act of mercy. "
 },
 {
   "Card": "Let Your Edges Be Liquid",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/LetYourEdgesBeLiquid.png",
   "Description": "This is a softening spell that aligns its caster with the flow and fluidity of Water. The effects, like all magic, are immediate."
 },
 {
   "Card": "Life Is Beautiful Life Is Meaningful",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/LifeIsBeautiful920.png",
   "Description": "Until whatever great beyond comes to claim us, we are here, in a life abundant with beauty and meaning for those who dare to see and make it. Have you ever noticed that it’s precisely when hearts are most desperate that these tiny offerings are slipped underneath the door?"
 },
 {
   "Card": "Love Garden",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/LoveGarden.png",
   "Description": "Now is the time to look around and take stock of your resources; what you will behold are the labors of your Love. What fruits have your efforts grown? What nourishment has your Love produced? Even the most flourishing Love Gardens are subject to the seasons, and the most efficacious gardeners know periods of fallow lend themselves to abundant harvests. That the sweet spot between blind faith and earned trust is where things grow. That fruitful times are always ahead. That nutrients replenish beneath the surface if afforded the patience. \n \nWith nurturing and preparation, a garden like this can support someone year-round, for all the years, should they so wish."
 },
 {
   "Card": "Love Hate Light Shadow",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/LoveHateLightShadow.png",
   "Description": "The line of dualism can only be toed for so long before coming to suspect the concepts of good and evil are nothing more than the same room peered through alternate vantage points at different times of day. \n \nAny truth to be found in a dualistic universe will contain within it some amount of paradox, among them being that a thing’s existence is interdependent on the existence of its opposite."
 },
 {
   "Card": "Maybe Next Time",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/MaybeNextTime.png",
   "Description": "Your current desires do not align with your best interests at this Time. All yearnings that present themselves as urgent should be subject to critical examination. This answer is firm, but not unfriendly. You will have the opportunity to try again. \n \nTime is the only truly limited resource, infinite in and of itself but finite to those of us perceiving it. Like all forces that exist within as well as beyond our understanding, Time is with us, but not exclusively for us. Our choice to assume its perfection or despair in its chaos does not change the unrelenting nature of its ticking. \n \nAccept this outcome. Find the Strange Perfection in this Strangely not Perfect Timing. "
 },
 {
   "Card": "Miracle Mile",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/MiracleMile.png",
   "Description": "A flower’s perfect blossom is only a snapshot amidst an entire life cycle, but that does not stop it from blooming its head off without reservation when the time comes. You have found yourself in a flourishing phase. Life is not perfect, but it has perfect moments and those moments are Miracles. There is nothing for you to do but relish it. Deeply breathe the rarefied air and bloom."
 },
 {
   "Card": "My God Has Answered",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/MyGodHasAnswered920.png",
   "Description": "A mother prays for a daughter and, upon giving birth to one, gives her two names.\n \nבקרה אליאנה                                     \n \nBakara, First Born Daughter. \nEliana, My God Has Answered. \n \nTo speak the name is to exalt in an answered prayer for life."
 },
 {
   "Card": "The Next Right Thing",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/NextRightThing.png",
   "Description": "It may not be easy, but in this case it’s simple. The Next Right Thing will require no justification or deception. It will cause no harm. Follow its light to The High Road and take that all the way down to Miracle Mile."
 },
 {
   "Card": "No Kings But Us",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/NoKingsButUs.png",
   "Description": "You are the cumulative, mighty efforts of your ancestors. You are their wish granted and dream realized. You are miraculous. You are ancient and you are holy. You are the sum of Fate, Time, Love and Luck, all conspiring together. You are an instrument, fine-tuned to bring forth the sometimes euphonious, sometimes cacophonous, and always harmonious rhythms and tickings of this universe. You are here to play and you are here to dance. \n \nOn the matter of Kings, there is fact and fiction among the lore. They are divinely assigned, it’s true, but they are not as rare as you’ve been made to believe. Rather, they are an archetypal energy awakened within as soon as you begin to ask, “why not me?”\n\nYou are it. If you don’t like it, change it. If it’s not there, create it."
 },
 {
   "Card": "No Vacancy",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/NoVacancy.png",
   "Description": "The portal is now closed on a memory that once offered Nostalgia, comfort and fond feelings. This empty but no longer vacant space is uninhabitable even to your imagination. The land of the living is knocking and knocking and ticking and tocking, inviting you back, demanding your presence. While bittersweet, outgrowing old vices (the past being one of the most enticing of them all) is a step toward liberation and maybe even eternal bliss, too. \n \nA promise to the haunted and heartbroken that you will soon be gone from this place and it from you."
 },
 {
   "Card": "Parasitism",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Parasitism.png",
   "Description": "Symbiosis speaks to the interactions of different organisms living in close association. Typically assumed to be favorable for both parties, there are in fact three classifications of symbiotic relationships:\n\nMutualism, wherein both organisms benefit\nCommensalism, advantageous to one organism and neutral to the other\nParasitism, in which one organism profits at the expense of the other. \n\nParasites evolve to subvert the natural defenses of their host. Or otherwise, the host is wounded or weakened in such a way that makes them susceptible to the parasite on an intercellular and intracellular level. \n\nIt’s interesting to note that while a parasite is perceived as negative to the individual experiencing it, they are a natural component of any ecosystem. An estimated 40% of animal species are parasites, which means that, in any given habitat, the constructive only slightly outweighs the destructive. This shadow side of symbiosis is too part of nature’s checks and balances system.  Even the parasite serves to maintain the overall wellness of its ecosystem.\n\nWhile their occurrence is inevitable, any and all identified parasites must be removed immediately. Do not hesitate to seek the help of trained medical professionals if the situation calls for it."
 },
 {
   "Card": "The Passing Of Time",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/PassingOfTime920.png",
   "Description": "Time devours.\nTime heals.\nTime flies.\nTime out. \nTime up.\nTime was. \nTime comes.\nTime waits for no one. "
 },
 {
   "Card": "Playing God",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/PlayingGod.png",
   "Description": "Resist the joyless impulse to micromanage your life or the lives of others. Nothing meant for you will require being controlled in this way. Attempts to do so are futile by design and lead to loneliness and conflict. Surrender is victory. Surrender to what is, to what wants you and what doesn’t."
 },
 {
   "Card": "Protection",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/Protection.png",
   "Description": "This image, strengthened by each individual who gazes upon it, casts a spell of Protection upon the querent. Whether invoked yourself or petitioned by Spirit on your behalf, it’s now enacted until any active threats subside. \n \nAnyone who has worn a suit of armor or implemented a credit freeze knows the gift of protection comes with the weight of its burdens. Effective Protection is somewhat clunky, and guards its subject against both peril and pleasure. No harm will come to you here, but nothing new will happen either. Stay only as long as you must."
 },
 {
   "Card": "Quiet Desperation",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/QuietDesperation.png",
   "Description": "Who among us hasn’t spent hours, evenings, months and maybe even years waiting? Waiting by the phone for a call that never comes. Waiting for a break, a reason, an answer, an apology, an opportunity, a sign to go or a sign to stay. Unrequited feelings live here, regret and milk-toothed hope. \n \nThe Soul, knowing Magic is Immediate, revolts against this self-imposed state of suspended animation. You are likely waiting on something you are meant to give yourself. "
 },
 {
   "Card": "Reason To Live Juice",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/ReasonToLiveJuice.png",
   "Description": "Reason to Live Juice is a deeply personal cocktail of whatever helps you get through the day. Each day is different, as is what it demands of the living. While it’s possible this brew is spiked with maladaptive coping mechanisms, addictions and disorders, there is more medicine than malady at the heart of human motivation. \n\nMeandering strolls, meaningful conversations, bright memories, tender touches, scrumptious meals, profound art, inspiring architecture, love letters, a stomach full of butterflies, braiding a friend’s hair, the night before a vacation, your dreams for the future, the smell of old books and strong coffee and veggies fat and glowing on the vine all too reside in this mysterious mixture of the human Soul that makes us rise to fight another day."
 },
 {
   "Card": "Rewritten History",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/RewrittenHistory920.png",
   "Description": "Books possess a magic greater than the sum of their parts. From society’s earliest documentation, efforts to immortalize and pass on lessons learned can be found stenciled on the walls of prehistoric caves, hinted at in art, masonry, tools, clothing, architecture and, most importantly, books. Regardless of the language, they are a hallowed clue of the intricate web connecting us all through time and space. \n \nTotalitarian regimes often target culture, specifically literature, because we are a people who understand ourselves through story. All literature is dangerous to an authority that fears the free flow of ideas. A population cannot be controlled without also controlling the information it consumes. More than a fundamental repression of ideas, this erasure of a peoples' history, culture and humanity is a step toward erasing the people themselves.\n \nWhat can be so dangerous in a book, or about a truth, that would call for its annihilation? Under what circumstances would a highly intelligent nation burn its books? Under what conditions might a highly intelligent person rewrite their history? Even you, perhaps, in this instance?\n \nTLDR: keep receipts, for everyone’s sake."
 },
 {
   "Card": "Season Of The Witch",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/SeasonOfTheWitch.png",
   "Description": "Recent tidings brought cataclysmic change, with more to come. Those on Earth at this time find themselves amidst a reckoning. \n \nPrepare your ritual, fine-tune your magic, bring an offering to the apocalyptic potluck. You were born for this, after all."
 },
 {
   "Card": "Show Me Your Original Face, The Face You Had Before Your Parents Were Born",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/ShowMeYourOriginalFace.png",
   "Description": "Utilize this Chinese Zen koan to temporarily slip through linear time. A jumping off point for imagination, meditation and realization. The notion of an Original Face has been long-explored in Buddhism to refer to an ultimate reality, only accessible when all misconceptions and unrealities have been removed. Life is designed to make us forget our Original Face. To die is to remember. Glimpses are available to the living through Spirituality."
 },
 {
   "Card": "Sky Daddy",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/SkyDaddy920.png",
   "Description": "The Sun is the supreme archetypal patriarch. Fearsome in its power but gentle enough to nurture life. A source of consistency, dependability and routine. Mighty in all it does – its jubilation and exuberance, its sorrow and its rage. Shining, energizing and scorching indiscriminately. \n \nTo worship Sky Daddy is to let the sunshine cup your face, to work in the garden, to find shapes in the clouds, to feel peace in a sunset. Those who have endured a Dark Night of the Soul know this to be sacred."
 },
 {
   "Card": "Sparkle Sparkle Bitch",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/SparkleSparkleBitch920.png",
   "Description": "Every being is, at their core, sparkling and luminous. Some call it Soul, some call it the bit of god dwelling in each of us; others just call it Sparkle Sparkle, Bitch. \n \nTo be unapologetically sparkly in a dull world is an act of resistance, and an act of hope, too."
 },
 {
   "Card": "Spell It Out",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/SpellItOut.png",
   "Description": "State your intention. Define your desires. Press pen to paper and make it so. Once a thought, now ink glistening on a page. Endless possibilities await."
 },
 {
   "Card": "Storm & Fury",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/StormandFury.png",
   "Description": "A power born of rage, destructive and vengeful in nature, which amplifies the potency of curse magic. A last resort kind of magic. The dying cries of the tortured, discarded and unvindicated kind of magic. The planet remembers. The water remembers. The bloodied soil remembers and what grows from it remembers. If Justice is not offered willingly, Storm & Fury will restore it by force. "
 },
 {
   "Card": "Strangely Perfect Timing",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/StrangelyPerfectTiming.png",
   "Description": "The daring traveler may slip between Time’s tickings. Expand it, skip pebbles through its waters and peer between its curtains. The wise one knows better. \n \nTo receive something ahead of time can be more damaging than a late or null arrival. To seek or possess premature information may induce madness. A fruit is ripest just before it rots. A dream, a few seconds before, was a nightmare. A birth too early is a death. There is no benefit to getting ahead of Time. Follow its lead and arrive not late or early, not rushing or idling, but Strangely, Perfectly on Time."
 },
 {
   "Card": "Tag You're It",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/TagYoureIt.png",
   "Description": "Boo! All eyes on you! Whether wished for or unexpected, your fifteen minutes of fame are upon you. Bring forward what you want amplified by the power of this collective attention. Fearlessly show yourself. Say your piece with all your heart. Then take a bow, collect your flowers and get off the stage. There’s another act right behind you."
 },
 {
   "Card": "There And Back Again",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/ThereAndBackAgain.png",
   "Description": "We must venture forward. We must answer the call. We must be bold and brave. We must leave all we’ve known behind and make our own way. We must slay the dragon, capture the gold and reach the mountaintop. And then we must go Home, where our treasure has been all along."
 },
 {
   "Card": "They Know Not What They Do",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/TheyKnowNotWhatTheyDo.png",
   "Description": "If they don’t know, chances are it's because they don’t want to. \n \nYou cannot get between someone and a decision they’re determined to make, and it would be a kind of insanity to try. If you know what’s good for you, you’ll get out of the way before this flaming dumpster falls on your head, too.\n \nGive those who have earned it the grace to make mistakes without criticism or condemnation while loving yourself enough to stay out of the blast radius while they do so. All you can do is trust people to show you who they really are. Regret and blame are futile, but self-preservation lends itself to objective observation. \n \nLet people go away and, if it’s well with your Soul, let them come back."
 },
 {
   "Card": "¯\\_(ツ)_/¯ Tra La La",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/TraLaLa920.png",
   "Description": "Save your energy and let it miss you with this succinct, euphonious spell that, when coupled with a shrug, prevents frustrating or baffling matters from occupying undue attention. May be used preventatively for maximum compartmentalization."
 },
 {
   "Card": "Trust The Process",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/TrustTheProcess.png",
   "Description": "And in the meantime, bless the mess."
 },
 {
   "Card": "Until All Are Free None Are Free",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/UntilAllAreFree.png",
   "Description": "Your liberation is inextricably tied to the liberation of this planet and every living being on it. This Truth can no longer be hidden or unseen."
 },
 {
   "Card": "Until The Day Breaks And The Shadows Flee Away",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/UntilTheDayBreaks920.png",
   "Description": "The living fear being haunted by the dead, but the dead welcome being haunted by the living. Visit the dead. Visit your dead, if possible. Among them it’s evidenced that love is eternal, that life leaves traces beyond death, that there is solace in the somber. And Death…the uninterrupted quiet of it all. So much more peaceful and patient than we’re made to believe."
 },
 {
   "Card": "Water Has Memory",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/WaterHasMemory.png",
   "Description": "Ancient magics of all sorts work interdependently to weave together and animate our forms, water being the most prolific of them all. The vast majority of the human body is made up of water. The brain and heart are 73% water. The lungs, 83%; the muscles and kidneys, 79%; the skin 64%; even bones are 31% water. The water that constitutes us, like the stardust in our bones, has journeyed long before we came here and will continue long after we leave. \n \nLacking any neuronal tissue, Water is not considered alive in any traditional sense, and yet no life is possible without it."
 },
 {
   "Card": "X Marks The Spot",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/XMarksTheSpot.png",
   "Description": "For those following their treasure map to their heart, X can only mean one thing. Were you here on a mission? You can’t remember. But here you are, finally."
 },
 {
   "Card": "You Came Here To Help Turn Off The Lights",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/YouCameHereToHelp.png",
   "Description": "Heard upon waking, whispered into an empty room. Intuitively understood."
 },
 {
   "Card": "You May Never Know",
   "Image": "https://cdn.shopify.com/s/files/1/1150/7634/files/YouMayNeverKnow.png",
   "Description": "And, truth be told, what would be gained at this point if you did?\n           \n“Be patient toward all that is unsolved in your heart and try to love the questions themselves, like locked rooms and like books that are now written in a very foreign tongue. Do not now seek the answers, which cannot be given you because you would not be able to live them. And the point is, to live everything. Live the questions now. Perhaps you will then gradually, without noticing it, live along some distant day into the answer.” \n- Rainer Maria Rilke"
 }
];


let cards = document.querySelectorAll(".card");
let cardsMidIndex = Math.floor(cards.length / 2);
let yOffset = 25;
let scaleOffset = 0;
let duration = 0.8;
let scaleDuration = duration / 3;
let tl = gsap.timeline({ repeat: -1, yoyoEase: true });
var overflowTimeout;

function driftIn() {
  return gsap.timeline().from(".cards", {
    yPercent: -yOffset / 3,
    duration,
    ease: "power2.inOut",
    yoyoEase: true
  });
}

function driftOut() {
  return gsap.timeline().to(".cards", {
    yPercent: yOffset / 3,
    duration,
    ease: "power2.inOut",
    yoyoEase: true
  });
}

function scaleCards() {
  return gsap
    .timeline()
    .to(".card", {
      scale: (i) => {
        if (i <= cardsMidIndex) {
          return 1 - i * scaleOffset;
        } else {
          return 1 - (cards.length - 1 - i) * scaleOffset;
        }
      },
      delay: duration / 3,
      duration: scaleDuration,
      ease: "expo.inOut",
      yoyoEase: true
    })
    .to(".card", { scale: 1, duration: scaleDuration });
}

function shuffleCards() {
  return gsap
    .timeline()
    .set(".card", {
      y: (i) => -i * 0.5
    })
    .fromTo(
      ".card",
      {
        rotate: 45,
        yPercent: -yOffset
      },
      {
        duration,
        rotate: 65,
        yPercent: yOffset,
        stagger: duration * 0.03,
        ease: "expo.inOut",
        yoyoEase: true
      }
    );
}

function shuffleDeck() {
  tl.add(driftIn())
    .add(shuffleCards(), "<")
    .add(scaleCards(), "<")
    .add(driftOut(), "<55%");
}

shuffleDeck();
// The shuffle is hidden until a reading starts; don't burn CPU animating it before then.
tl.pause();

const tarotSwiper = new Swiper('.tarot-deck-slider', {
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    slidesPerView: 'auto',
    mousewheel: {
        forceToAxis	: true
      },
      freeMode: {
        enabled: true,
        sticky: true,
      },
      navigation: {
        nextEl: '.nextarrow',
        prevEl: '.backarrow',
      },
      on: {
        setTransition: function (e) {
          $('html,body').css('overscroll-behavior-x','none');
          window.clearTimeout(overflowTimeout);
          overflowTimeout = window.setTimeout(function(){
            $('html,body').css('overscroll-behavior-x','unset')
          }, 300); 
        }      
       }
  });

var cardCount = 'one';
var deck;
var readingStarted = false;

// Postcards from the Liminal Space (oracle deck), app exclusive. Dates, name and app-only come from the section's
// theme editor settings (window.LIMINAL_SPACE_SETTINGS). Days are New York days: the deck opens at midnight New York
// time on the first day and closes at midnight after the last day, the same moment whatever the phone's timezone.
// "Now" comes from Shopify's server clock, so changing the phone's clock doesn't unlock it early or keep it late.
// The cards themselves (liminal-space-cards.js) load only when the deck is offered.
// ?liminal_preview=1 forces it on for review, on preview/unpublished themes only (never on the live theme).
var liminalspacecards = [];
var liminalSpaceBack = null;
var liminalSpaceSettings = window.LIMINAL_SPACE_SETTINGS || {};

// "2026-10-31" or "10/31/2026" -> {y, m, d}; anything else (or an impossible date) -> null.
function parseDeckDay(text) {
  var s = String(text || '').trim(), m, y, mo, d;
  if ((m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) { y = +m[1]; mo = +m[2]; d = +m[3]; }
  else if ((m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) { y = +m[3]; mo = +m[1]; d = +m[2]; }
  else return null;
  var check = new Date(Date.UTC(y, mo - 1, d));
  if (check.getUTCFullYear() !== y || check.getUTCMonth() !== mo - 1 || check.getUTCDate() !== d) return null;
  return { y: y, m: mo, d: d };
}

// Midnight in New York at the start of that day, as a timestamp. It is 04:00 UTC in daylight time, 05:00 UTC otherwise.
function newYorkMidnight(y, m, d) {
  var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric' });
  var candidates = [4, 5];
  for (var i = 0; i < candidates.length; i++) {
    var t = Date.UTC(y, m - 1, d, candidates[i]), parts = {};
    fmt.formatToParts(new Date(t)).forEach(function(p) { parts[p.type] = +p.value; });
    if (parts.year === y && parts.month === m && parts.day === d && parts.hour === 0) return t;
  }
  return Date.UTC(y, m - 1, d, 5);
}

function liminalSpaceWindow() {
  var first = parseDeckDay(liminalSpaceSettings.start), last = parseDeckDay(liminalSpaceSettings.end);
  if (!first || !last) return null;
  var after = new Date(Date.UTC(last.y, last.m - 1, last.d + 1));
  var opens = newYorkMidnight(first.y, first.m, first.d);
  var closes = newYorkMidnight(after.getUTCFullYear(), after.getUTCMonth() + 1, after.getUTCDate());
  return closes > opens ? { opens: opens, closes: closes } : null;
}

function liminalSpacePreviewing() {
  var onLiveTheme = window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main';
  return !onLiveTheme && /[?&]liminal_preview=1(&|$)/.test(window.location.search);
}

// Shopify's clock, from the Date header of a tiny request the store always answers. Falls back to the phone if offline.
function liminalSpaceNow(done) {
  if (!window.fetch) return done(Date.now());
  var asked = Date.now();
  fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
    .then(function(response) {
      var server = Date.parse(response.headers.get('Date'));
      done(isNaN(server) ? Date.now() : server + (Date.now() - asked) / 2);
    })
    .catch(function() { done(Date.now()); });
}

// Where the gate landed, for support and tests: 'hidden' | 'checking' | 'loading' | 'shown'.
function liminalSpaceState(state) { window.LIMINAL_SPACE_STATE = state; }

function loadLiminalSpace() {
  liminalSpaceState('loading');
  var script = document.createElement('script');
  script.src = liminalSpaceSettings.dataUrl;
  script.async = true;
  script.onload = function() {
    liminalspacecards = window.LIMINAL_SPACE_CARDS || [];
    liminalSpaceBack = window.LIMINAL_SPACE_BACK;
    if (!liminalspacecards.length || !liminalSpaceBack || readingStarted) return liminalSpaceState('hidden');
    if (!$('#tarotDeck option[value="liminalspace"]').length) {
      $('#tarotDeck option[value="liminal"]').after($('<option>').val('liminalspace').text(liminalSpaceSettings.name || 'Postcards from the Liminal Space'));
    }
    liminalSpaceState('shown');
  };
  script.onerror = function() { liminalSpaceState('hidden'); };
  document.head.appendChild(script);
}

function offerLiminalSpace() {
  liminalSpaceState('hidden');
  if (!liminalSpaceSettings.dataUrl) return;
  if (liminalSpacePreviewing()) return loadLiminalSpace();
  if (liminalSpaceSettings.enabled === false) return;
  var inApp = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  if (liminalSpaceSettings.appOnly !== false && !inApp) return;
  var span;
  try { span = liminalSpaceWindow(); } catch (e) { span = null; }
  if (!span) {
    if (window.console) console.warn('Postcards from the Liminal Space: check the First day / Last day settings (use 2026-10-31 or 10/31/2026).');
    return;
  }
  liminalSpaceState('checking');
  liminalSpaceNow(function(now) {
    if (now >= span.opens && now < span.closes) loadLiminalSpace();
    else liminalSpaceState('hidden');
  });
}

offerLiminalSpace();


// keepCount: leave the card count alone (used when the browser restored the form on Back/Forward).
function applyDeck(selectedval, keepCount) {
  if(selectedval == 'wayhome' || selectedval == 'liminal' || selectedval == 'liminalspace') {
    $('.sunday-reading-preview').hide();
    $('.tarot-cards-teaser').show();
    if (!keepCount) $('#cardCount').val("one");
    $('#cardCount').prop("disabled", false);
  }
  else if (selectedval == 'reading') {
    $('.sunday-reading-preview').show();
    $('.tarot-cards-teaser').hide();
    $('#cardCount').val("six").prop( "disabled", true); 
  }


  if(selectedval == 'wayhome') {
    $('.tarot-cards-teaser img').attr("src", "https://cdn.shopify.com/s/files/1/1150/7634/files/Card_Back_result_584a42fc-d25e-4446-b4e5-f84751fcbfde.png?v=1728576419"); 
  }
  else if(selectedval == 'liminal') {
    $('.tarot-cards-teaser img').attr("src", "https://cdn.shopify.com/s/files/1/1150/7634/files/Card.png?v=1733690103");
  }
  else if(selectedval == 'liminalspace') {
    $('.tarot-cards-teaser img').attr("src", liminalSpaceBack);
  }
}

$('#tarotDeck').change(function() {
  applyDeck($(this).val(), false);
});

// Browsers restore the dropdowns on Back/Forward; make the page match what was restored.
function syncRestoredDeck() {
  if (!readingStarted) applyDeck($('#tarotDeck').val(), true);
}
syncRestoredDeck();
$(window).on('pageshow', syncRestoredDeck);

// Enter/Space activate the start button like a real button. (The face-down cards stay unfocusable on purpose:
// on iOS, focusing a tapped card makes Safari scroll the slider natively and the next tap lands on the wrong card.)
$('#startTarot').on('keydown', function(e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    $(this).trigger('click');
  }
});

// iPhone: the site's accessibility widget sets itself up during the first touch on a page, and Safari then cancels
// that tap's click (so "I'm Ready" needed two taps after Start Over). Start on a clean tap (finger didn't move)
// straight from the touch events; readingStarted makes the click that may follow a no-op.
(function() {
  var startButton = document.getElementById('startTarot'), touch = null;
  if (!startButton) return;
  startButton.addEventListener('touchstart', function(e) { touch = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, { passive: true });
  startButton.addEventListener('touchmove', function(e) {
    if (touch && (Math.abs(e.touches[0].clientX - touch.x) > 10 || Math.abs(e.touches[0].clientY - touch.y) > 10)) touch = null;
  }, { passive: true });
  startButton.addEventListener('touchcancel', function() { touch = null; }, { passive: true });
  startButton.addEventListener('touchend', function() { if (touch) { touch = null; $(startButton).trigger('click'); } }, { passive: true });
})();

$('#startTarot').click(function() {
    if (readingStarted) return;
    readingStarted = true;
    tl.play();
    cardCount = $('#cardCount').val();
    deck = $('#tarotDeck').val();
    $('.tarot-cards-teaser').addClass('lets-shuffle');
    $('.intro-container').addClass('fadeout');
    $('.tarot-reading-outer').addClass(`deck-${deck}`);
    $('.sunday-reading-preview').addClass('fadeout');
    $('.stars').addClass('hidestars');
    $('.tarot-reading-outer').addClass('shuffling');

    if(deck == 'wayhome') {
      var generatedNumbers = generateRandomNumbers(78, 0, 77);
      $('.oracle-card-slide').addClass('hide-card');
      $(".tarot-card-slide").each(function(index) {
        $(this).attr("data-index",generatedNumbers[index]);
      });
    }
    else if (deck == 'liminal') {
      var generatedNumbers = generateRandomNumbers(77, 0, 76);
      $('.tarot-card-slide').addClass('hide-card');
      $(".oracle-card-slide").each(function(index) {
        $(this).attr("data-index",generatedNumbers[index]);
      });
    }
    else if (deck == 'liminalspace') {
      var generatedNumbers = generateRandomNumbers(liminalspacecards.length, 0, liminalspacecards.length - 1);
      $('.tarot-card-slide').addClass('hide-card');
      $('.oracle-card-slide img').attr("src", liminalSpaceBack);
      $('.oracle-deck-cards .card').css('background-image', 'url("' + liminalSpaceBack + '")');
      $(".oracle-card-slide").each(function(index) {
        $(this).attr("data-index",generatedNumbers[index]);
      });
    }
    else if(deck == 'reading') {
      var generatedNumbers = generateRandomNumbers(77, 0, 76);
      var generatedNumberssecond = generateRandomNumbers(78, 0, 77);
      $('.tarot-card-slide').addClass('hide-card');
      
      $(".oracle-card-slide").each(function(index) {
        $(this).attr("data-index",generatedNumbers[index]);
      });

      $(".tarot-card-slide").each(function(index) {
        $(this).attr("data-index",generatedNumberssecond[index]);
      });
    }    

    setTimeout(() => {
        $('.intro-container h1 p').html('Shuffling...');
        $('.intro-container span, .intro-container form, .intro-container div,.tarot-cards-teaser').remove();
        $('.intro-container').removeClass('fadeout');
        $('.intro-container').addClass('fadein');
        $('.tarotShuffle').addClass('showshuffle');
        $('.sunday-reading-preview').remove();
    }, 600);
    setTimeout(() => {
        $('.tarotShuffleFlex').addClass('fadeout');
        $('.intro-container').removeClass('fadein').addClass('fadeout');
        setTimeout(() => {
        $('.tarotShuffle').removeClass('showshuffle');

          if(deck == 'reading') {
            $('.pull-a-card-heading').html('Select Mind, Body, and Spirit Cards');
          }
          
            $('.tarotShuffle').remove();
            tl.kill();
            $('.tarotShuffleFlex').remove();
          
            if(cardCount == 'one') {
                $('.intro-container h1 p').html('Select a Card');
            }
            else if(cardCount == 'three' || deck == 'reading') {
                $('#cardsToSelect').html('3');
                $('.intro-container h1 p').html('Select 3 Cards');
            }
            else if(cardCount == 'six') {
                $('#cardsToSelect').html('6');
                $('.intro-container h1 p').html('Select 6 Cards');
            }
            $('.intro-container').addClass('fadein').removeClass('fadeout');
            $('.tarot-deck').addClass('showdeck');
            $('.tarot-reading-outer').removeClass('shuffling');
            tarotSwiper.update();
        }, 700);
    }, 4500);
});

function hideDeck() {
    setTimeout(() => {
        $('.tarot-deck').addClass('fadeout');
        $('.intro-container').removeClass('fadein').addClass('fadeout');
    }, 300);
    setTimeout(() => {
        $('.tarot-deck').removeClass('showdeck');
    }, 750);
}

function generateRandomNumbers(count, min, max) {
    if (count > max + 1) {
      return "count cannot be greater than the upper limit of range";
    } else {
      let uniqueNumbers = new Set();
      while (uniqueNumbers.size < count) {
        uniqueNumbers.add(Math.floor(Math.random() * (max - min + 1)) + min);
      }
      return Array.from(uniqueNumbers);
    }
  }

 // Card text goes into HTML and attributes; escape it so a quote or bracket in the copy can't break the page.
 function esc(value) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
 }

 var selectedCardIndexes = [];
 var selectedCards = [];
 var cardbuckets = ['Mind', 'Body', 'Spirit', 'Past', 'Present', 'Future'];

 function generateLayout(cardcount) {
    if(cardcount > 1) {
        var layout = `
            <div class="multiple-cards loadingImages">
                <div class="copyContain">
                    <h2 class="grid__heading ff-heading fs-heading-3-base section-introduction__heading">${drawnHeadline}</h2>
                    <span>${drawnCopy}</span>
                    <div class="buttonFlex">    
                    
            <div id="startOver" class="button-block__button button-block__button--justify-center button-block__button--justify-mobile-center image-with-text-split__text-container-button section-blocks__button" style="--delay-offset-multiplier: 8;">
                <div class="
                btn
                  btn--overlay
                btn--primary">
              <span>Start Over</span>
                </div>
          </div>


            <div class="explorebtn button-block__button button-block__button--justify-center button-block__button--justify-mobile-center image-with-text-split__text-container-button section-blocks__button" style="--delay-offset-multiplier: 8;">
                <a href="#explore" class="
                btn
                  btn--overlay
                ">
              <span>Explore More</span>
                </a>
          </div>


                    </div>
                </div>

                <div class="imagesContain">
                  ${Object.keys(selectedCards).map(function (index,key) {
                    return `<div class="multimageContain">

                    ${cardcount > 3 ? `<h2 class="grid__heading ff-heading fs-heading-4-base section-introduction__heading">${cardbuckets[index]}</h2>` : ''}
                    
                    <div class="imageInner">
                    <span class="loader"></span>
                    <img src="${esc(selectedCards[key].Image)}" alt="${esc(selectedCards[key].Card)}"/>
                    </div>
                    <span class="cardTitle ${selectedCards[key]?.Light || selectedCards[key]?.Dark ? '' : 'oracle-card-title'}">${esc(selectedCards[key].Card)}</span>
                    <span class="cardDesc ${selectedCards[key]?.Light || selectedCards[key]?.Dark ? 'increase-line-height' : ''}" data-title="${esc(selectedCards[key].Card)}" data-description="${esc(selectedCards[key].Description)}" data-light="${esc(selectedCards[key].Light)}" data-dark="${esc(selectedCards[key].Dark)}">About This Card</span>
                    </div>`
                }).join("")}
                </div>
            </div>
            `
    }
    else {
            var layout = `
            <div class="single-card sidebyside loadingImages">
                <div class="copyContain sidebyside50">
                    <h2 class="grid__heading ff-heading fs-heading-3-base section-introduction__heading">${drawnHeadline}</h2>
                    <span>${drawnCopy}</span>
                    <div class="buttonFlex">    
                    
            <div id="startOver" class="button-block__button button-block__button--justify-center button-block__button--justify-mobile-center image-with-text-split__text-container-button section-blocks__button" style="--delay-offset-multiplier: 8;">
                <div class="
                btn
                  btn--overlay
                btn--primary">
              <span>Start Over</span>
                </div>
          </div>


            <div class="explorebtn button-block__button button-block__button--justify-center button-block__button--justify-mobile-center image-with-text-split__text-container-button section-blocks__button" style="--delay-offset-multiplier: 8;">
                <a href="#explore" class="
                btn
                  btn--overlay
                ">
              <span>Explore More</span>
                </a>
          </div>


                    </div>
                </div>
                <div class="imageContain sidebyside50">
                
                <div class="imageContainSingle">
                    <span class="loader"></span>
                    <img src="${esc(selectedCards[0].Image)}" alt="${esc(selectedCards[0].Card)}"/>
                </div>
                    <span class="cardTitle ${selectedCards[0]?.Light || selectedCards[0]?.Dark ? '' : 'oracle-card-title'}">${esc(selectedCards[0].Card)}</span>
                    <span class="cardDesc" data-title="${esc(selectedCards[0].Card)}" data-description="${esc(selectedCards[0].Description)}" data-light="${esc(selectedCards[0].Light)}" data-dark="${esc(selectedCards[0].Dark)}">About This Card</span>
                </div>
            </div>
            `
       
    }

    $('.tarot-reading-outer').addClass('your-reading');
    setTimeout(() => {
        $('.intro-container').remove();
        $('.tarot-reading-outer').append(layout);
        $('.explore-more').addClass('show-explore-more');
        $('.loadingImages').waitForImages(function() {
          $(this).addClass('allimagesloaded');
        });
        setTimeout(() => {
            $('.tarot-reading-outer').removeClass('your-reading');
        }, 200);
    }, 1000);
 }

  
 function generateCards(data) {
    setTimeout(() => {
        $(".selectedCard").each(function() {
            selectedCardIndexes.push($(this).attr("data-index"));
        });
      
        if(deck == 'wayhome') {
        $.each(selectedCardIndexes, function(key,value) {
            selectedCards.push(tarotcards[value]);
        });
          generateLayout(selectedCards.length);
        }


       else if(deck == 'liminal') {
        $.each(selectedCardIndexes, function(key,value) {
            selectedCards.push(oraclecards[value]);
        });
          generateLayout(selectedCards.length);
        }

       else if(deck == 'liminalspace') {
        $.each(selectedCardIndexes, function(key,value) {
            selectedCards.push(liminalspacecards[value]);
        });
          generateLayout(selectedCards.length);
        }

      else if(deck == 'reading') {
        if(data == 'oracle') {
          $.each(selectedCardIndexes, function(key,value) {
            selectedCards.push(oraclecards[value]);
          });
          $('.oracle-card-slide').addClass('hide-card');
          $('.tarot-card-slide').removeClass('hide-card');
          $('#cardsSelected').html(0);
          $('.cardSlide').removeClass('selectedCard');
          $('.cardSlide').removeClass('disabled');
          selectedCardIndexes = [];
          $('.pull-a-card-heading').html('Select Past, Present, and Future Cards');
          tarotSwiper.update();
          tarotSwiper.slideTo(0, 0)	
        }
        else if(data == 'wayhome') {
          $.each(selectedCardIndexes, function(key,value) {
            selectedCards.push(tarotcards[value]);
          });          
          generateLayout(6);
        }
      }
      
    }, 100);
 } 


  
 var oracleInit = false; 
$('.cardSlide').click(function(){
    // Ignore taps once the reading has all its cards, or on cards from the other deck.
    if ($(this).hasClass('disabled') || $(this).hasClass('hide-card')) return;
    $(this).toggleClass('selectedCard');
    $('#cardsSelected').html($('.selectedCard').length);

    if(deck == 'reading') {
      if ($('.selectedCard').length == 3) {
        if(oracleInit == true) {
          generateCards('wayhome');
          hideDeck();
        }
        else {
          generateCards('oracle');
          $('.cardSlide').addClass('disabled');
          oracleInit = true;
        }
      }
    }
    else if ((cardCount == 'one' && $('.selectedCard').length == 1) || (cardCount == 'six' && $('.selectedCard').length == 6) || (cardCount == 'three' && $('.selectedCard').length == 3)) {
        $('.cardSlide').addClass('disabled');
        hideDeck();
        generateCards();
    }
  
});

$("body").on( "click", "#startOver", function() {
    location.reload();
});

$("body").on( "click", ".closeDescPopup", function() {
    $('.desc-popup').remove();
});

$(document).on('keydown', function(e) {
    if (e.key === 'Escape') $('.desc-popup').remove();
});
  

$("body").on( "click", ".cardDesc", function() {
    let description = $(this).attr('data-description');
    let light = $(this).attr('data-light');
    let dark = $(this).attr('data-dark');
    let title = $(this).attr('data-title');
    let increaseLineHeight = $(this).hasClass("increase-line-height");
    let popupTemplate = `<div class="desc-popup ${increaseLineHeight ? 'increase-line-height' : ''}">
      <div class="desc-popup-inner ${dark && dark != 'undefined' && dark ? 'has-dark-headline' : 'no-dark-headline'}">
        <div class="closeDescPopup"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"></path></svg></div>
          <h3>${esc(title)}</h3>
          <pre>${description && description != 'undefined' && description != '' ? esc(description) : ''}</pre>
          <pre>${light && light != 'undefined' && light != '' ? '<span class="lightHeadline"><b>Light:</b></span>' + esc(light) : ''}</pre>
          <pre>${dark && dark != 'undefined' && dark != '' ? '<span class="darkHeadline"><b>Dark:</b></span>' + esc(dark) : ''}</pre>
        </div>
        <div class="desc-popup-overlay closeDescPopup"></div>
      </div>`

  $('body').append(popupTemplate);
  
});
  

});